import React from 'react'
import './Header.css'

const Header = () => {
  return (
    <div className='header'>

<div className="header-contents">
<h2>Order your favourite office snack.</h2>
<p>Choose from our diverse menu featuring a delectable array of dishes crafted to meet executive office needs.</p>

<button>View Menu</button>


</div>


    </div>
  )
}

export default Header